import styles from './RoleRemoval.module.css';

import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

const dropReasons = [
    { value: 'wrong_selection', label: 'Selected wrong shift' },
    { value: 'illness', label: 'Illness/Not feeling well' },
    { value: 'injury', label: 'Injury' },
    { value: 'weather', label: 'Weather conditions' },
    { value: 'family_emergency', label: 'Family emergency' },
    { value: 'work_conflict', label: 'Work conflict' },
    { value: 'travel', label: 'Travel/Transportation issue' },
    { value: 'personal', label: 'Personal reasons' },
    { value: 'other', label: 'Other (specify below)' },
];

export const RoleRemoval = ({
    isRemovalMode,
    setRemovalMode,
    removalReason,
    setRemovalReason,
    removalNote,
    setRemovalNote
}) => {
    const handleRemovalToggle = (event) => {
        setRemovalMode(event.target.checked);
    };

    const handleReasonChange = (event) => {
        setRemovalReason(event.target.value);
        // Clear note if not 'other'
        if (event.target.value !== 'other') {
            setRemovalNote('');
        }
    };

    const handleNoteChange = (event) => {
        setRemovalNote(event.target.value);
    };

    return (
        <div className={ styles.removalSection }>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={ isRemovalMode }
                        onChange={ handleRemovalToggle }
                        className={ styles.removalCheckbox }
                    />
                }
                label="Remove me from this shift"
                className={ `${ styles.removalCheckboxLabel } ${ isRemovalMode ? styles.expanded : '' }` }
            />

            {/* Show reason dropdown when removal mode is active */ }
            { isRemovalMode && (
                <div className={ styles.removalForm }>
                    <FormControl fullWidth margin="dense">
                        <InputLabel className={ styles.reasonLabel }>
                            Reason for dropping shift
                        </InputLabel>
                        <Select
                            value={ removalReason }
                            onChange={ handleReasonChange }
                            label="Reason for dropping shift"
                            className={ styles.reasonSelect }
                            MenuProps={ {
                                PaperProps: {
                                    className: styles.reasonMenuPaper
                                }
                            } }
                        >
                            { dropReasons.map((reason) => (
                                <MenuItem
                                    key={ reason.value }
                                    value={ reason.value }
                                    className={ styles.reasonMenuItem }
                                >
                                    { reason.label }
                                </MenuItem>
                            )) }
                        </Select>
                    </FormControl>

                    {/* Show text field when 'other' is selected */ }
                    { removalReason === 'other' && (
                        <TextField
                            fullWidth
                            margin="dense"
                            label="Please specify"
                            placeholder="Enter reason for dropping shift..."
                            value={ removalNote }
                            onChange={ handleNoteChange }
                            multiline
                            rows={ 2 }
                            className={ styles.noteTextField }
                        />
                    ) }
                </div>
            ) }
        </div>
    );
};